import { render, staticRenderFns } from "./Lsyg.vue?vue&type=template&id=6b786aca&scoped=true"
import script from "./Lsyg.vue?vue&type=script&lang=js"
export * from "./Lsyg.vue?vue&type=script&lang=js"
import style0 from "./Lsyg.vue?vue&type=style&index=0&id=6b786aca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b786aca",
  null
  
)

export default component.exports